<!--<div class="exportprogressbar">
    <div class="download-header" >{{downloadtextflag}}</div>
<div class="progress">
    <div class="progress-bar" [ngStyle]="myStyle()">{{progressbarCount}}%</div>
  </div>
  <div class="cancel-div">

    <button (click)="cancelUpload()" type="button" class="btn btn-info text-right">Cancel</button>
      </div>

  </div>-->

  
  <div class="exportprogressbar" *ngIf="access != 'summary-job-report' && access != 'dealerUsage' && access != 'export-business' && access != 'export-sr' && access != 'thread-solr-export' && access != 'gbb-gts-report' && access != 'thread-solr-export-new' && access != 'summary-today' && access != 'techsupport-tickets' && access != 'summary-weekly' && access != 'gbb-jobs' && access != 'gbb-jobs-type-4' && access != 'dealerUsage-export'">
    <div class="download-header" >{{downloadtextflag}}</div>
<div class="progress">
    <div class="progress-bar" [ngStyle]="myStyle()">{{progressbarCount}}%</div>
  </div>
  <div class="cancel-div">

    <button (click)="cancelUpload()" type="button" class="btn btn-info text-right">Cancel</button>
      </div>

  </div>
  <div class="exportprogressbar" *ngIf="access == 'dealerUsage'">
    <!--div class="download-header" >{{downloadtextflag}}</div>
<div class="progress">
    <div class="progress-bar" [ngStyle]="myStyle()">{{progressbarCount}}%</div>
  </div-->
  <div class="download-header" >
    <div class="header-text">
      Downloading {{title}}<br/>  
      <div>
        <span class="header-text-dcode" *ngIf="dealerUserReport || employeeReport">{{usageTextStr}}<br/></span>
        <span *ngIf="!downloadUrlFlag">This may take a few minutes..</span>
      </div>
      <div *ngIf="downloadUrlFlag">       
        <span style="margin-top:8px;" class="download-link" (click)="clickDownloadURL()"><img class="pr-2" src="assets/images/common/calpro-download-icon.png" alt="download" /><span>Download Employee Report</span></span>
      </div>

    </div>
  </div>
  <div class="cancel-div"  *ngIf="!downloadUrlFlag">
    <button (click)="cancelUpload()" type="button" class="btn btn-info text-right">Cancel</button>
      </div>
      <div class="cancel-div"  *ngIf="downloadUrlFlag">
        <button (click)="closeUpload()" type="button" class="btn btn-info text-right">Close</button>
          </div>
  </div>
  <div class="exportprogressbar exportprogressbar-summary" *ngIf="access == 'summary-job-report'">
    <div class="download-header" >{{downloadtextflag}}</div>
<div class="progress">
    <div class="progress-bar" [ngStyle]="myStyle()">{{progressbarCount}}%</div>
  </div>
  <div class="cancel-div">

    <button (click)="cancelUpload()" type="button" class="btn btn-info text-right">Cancel</button>
      </div>

  </div>

  <div class="exportprogressbar exportprogressbar-summary export-ppp" *ngIf="access == 'export-sr' || access == 'export-business' || access == 'summary-weekly' || access == 'gbb-jobs' || access == 'gbb-jobs-type-4' || access == 'thread-solr-export' || access == 'summary-today' || access == 'techsupport-tickets' || access == 'dealerUsage-export'">
    <div class="header-close">
      <img *ngIf="downloadUrlFlag" (click)="closeUpload()" class="close-img cursor" src="assets/images/common/export-popup-close.png" alt="download" />
    </div>
    <div class="content-row">
      <div class="circle-div" *ngIf="!downloadUrlFlag"> 
        <img class="loading-img" src="assets/images/landing-page/loading-more.svg" alt="Loader" />
      </div>
      <div class="circle-img" *ngIf="downloadUrlFlag && resSuccess">
        <img class="loading-img" src="assets/images/common/export-popup-tick.png" alt="Loader" />
      </div>
      <div class="circle-img" *ngIf="downloadUrlFlag && !resSuccess">
        <img class="loading-img" src="assets/images/common/export-popup-nontick.png" alt="Loader" />
      </div>
      <div class="bold-text-div">
        <span *ngIf="!downloadUrlFlag">Generating Report..</span>
        <span *ngIf="downloadUrlFlag && resSuccess">Report Generated</span>
      </div>
      <div class="normal-text-div">
        <span *ngIf="!downloadUrlFlag">This may take a few minutes.</span>
        <span *ngIf="downloadUrlFlag && resSuccess">Download the report by clicking below</span>
        <span *ngIf="downloadUrlFlag && !resSuccess">{{resSuccessText}}</span>
      </div>
      <div class="but-div">
        <span class="btn-div-cancel" (click)="cancelUpload()" *ngIf="!downloadUrlFlag">CANCEL</span>
        <span class="btn-div-download" (click)="clickDownloadURL()" *ngIf="downloadUrlFlag && resSuccess">Download</span>
        <div class="m-2" *ngIf="downloadUrlFlag && !resSuccess"></div>
      </div>
    </div>
  </div>

  <div class="exportprogressbar exportprogressbar-summary export-ppp" *ngIf="access == 'thread-solr-export-new'">
    <div class="header-close">
      <img *ngIf="downloadUrlFlag" (click)="closeUploadNew()" class="close-img cursor" src="assets/images/common/export-popup-close.png" alt="download" />
    </div>
    <div class="content-row">
      <div class="circle-div" *ngIf="!downloadUrlFlag"> 
        <img class="loading-img" src="assets/images/landing-page/loading-more.svg" alt="Loader" />
      </div>
      <div class="circle-img" *ngIf="downloadUrlFlag">
        <img class="loading-img cursor" src="assets/images/common/export-popup-tick.png" alt="Loader" />
      </div>
      <!--div class="bold-text-div">
        <span *ngIf="!downloadUrlFlag">Generating Report..</span>
        <span *ngIf="downloadUrlFlag">Report Generated</span>
      </div-->
      <div class="normal-text-div">
        <span *ngIf="!downloadUrlFlag" style="color: #000000;">Report is being generated. We will send you an email once the report is ready to download.</span>
        <span *ngIf="downloadUrlFlag" style="color: #000000;">Report is being generated. We will send you an email once the report is ready to download.</span>
      </div>
      <div class="but-div">
        <span class="btn-div-cancel" (click)="cancelUpload()" *ngIf="!downloadUrlFlag">CANCEL</span>
        <span class="btn-div-ok" *ngIf="downloadUrlFlag" (click)="closeUploadNew()">OK</span>
      </div>
    </div>
  </div>

  <div *ngIf="access == 'gbb-gts-report'" class="exportprogressbar exportprogressbar-summary export-ppp">
    <div class="header-close">
      <img *ngIf="downloadUrlFlag" (click)="cancelGBBUpload()" class="close-img cursor" src="assets/images/common/export-popup-close.png" alt="download" />
    </div>
    <div class="content-row">
      <div class="circle-div" *ngIf="!downloadUrlFlag"> 
        <img class="loading-img" src="assets/images/landing-page/loading-more.svg" alt="Loader" />
      </div>
      <div class="circle-img" *ngIf="downloadUrlFlag">
        <img class="loading-img cursor" src="assets/images/common/export-popup-tick.png" alt="Loader" />
      </div>
      <div class="bold-text-div">
        <span *ngIf="!downloadUrlFlag">Generating Report..</span>
        <span *ngIf="downloadUrlFlag">Report Generated</span>
      </div>
      <div class="normal-text-div">
        <span *ngIf="!downloadUrlFlag">This may take a few minutes.</span>
        <span *ngIf="downloadUrlFlag">Download the report by clicking below</span>
      </div>
      <div class="but-div">
        <span class="btn-div-cancel" (click)="cancelGBBUpload()" *ngIf="!downloadUrlFlag">CANCEL</span>
        <span class="btn-div-download" (click)="closeGbbReport()" *ngIf="downloadUrlFlag">Download</span>
      </div>
    </div>
  </div>